export default __webpack_public_path__ + "static/media/Supervisor.373d62db.png";